<div class="container-fluid">
  <div class="page-head">
    <h5 class="header-title text-primary pl-2 pl-md-1">TRANSACTION SUMMARY</h5>
  </div>
</div>

<div class="container-fluid">
  <div class="row">
    <div class="col-lg-12">
      <div class="card m-b-30">
        <div class="card-body">
          <div class="row">
            <div class="col-lg-12">
              <button
                type="button"
                class="btn button-color btn-rounded text-white pl-4 pr-4 mr-4 mt-md-1 mt-2"
                [ngClass]="{ 'btn-primary': !activeBtn }"
                (click)="filterTransactions()"
              >
                ALL
              </button>
              <button
                type="button"
                class="btn button-color btn-rounded text-white pl-4 pr-4 mr-4 mt-md-1 mt-2"
                [ngClass]="{
                  'btn-primary': activeBtn === transactionStatus?.ON_HOLD
                }"
                (click)="filterTransactions(transactionStatus?.ON_HOLD)"
              >
                ON HOLD
              </button>
              <button
                type="button"
                class="btn button-color btn-rounded text-white pl-4 pr-4 mr-4 mt-md-1 mt-2"
                [ngClass]="{
                  'btn-primary': activeBtn === transactionStatus?.PROCESSED
                }"
                (click)="filterTransactions(transactionStatus?.PROCESSED)"
              >
                PROCESSED
              </button>
            </div>
          </div>

          <div class="row" *ngIf="transactions && transactions?.length > 0">
            <div class="col-md-12 mt-3 detail-tbl">
              <div class="table-responsive">
                <table class="table">
                  <thead>
                    <tr>
                      <th scope="col" class="font-size-15 font-weight-500 w-15">
                        &nbsp;
                      </th>
                      <th scope="col" class="font-size-15 font-weight-500 w-25">
                        TRANSACTION ID
                      </th>
                      <th scope="col" class="font-size-15 font-weight-500 w-15">
                        AMOUNT
                      </th>
                      <th scope="col" class="font-size-15 font-weight-500 w-15">
                        STATUS
                      </th>
                      <th scope="col" class="font-size-15 font-weight-500 w-25">
                        APPOINTMENT ID
                      </th>
                      <th scope="col" class="font-size-15 font-weight-500 w-25">
                        APPOINTMENT DATE
                      </th>
                      <th scope="col" class="font-size-15 font-weight-500 w-25">
                        APPOINTMENT TIME
                      </th>
                    </tr>
                  </thead>
                  <tr *ngFor="let trans of transactions">
                    <td class="font-size-15">
                      <div class="form-check ml-5">
                        <input
                          class="form-check-input"
                          type="checkbox"
                          [(ngModel)]="trans.isChecked"
                          id="defaultCheck1"
                          (change)="markSelected()"
                          *ngIf="trans?.on_hold"
                        />
                      </div>
                    </td>
                    <td class="font-size-15 text-color">{{ trans?.id }}</td>
                    <td class="font-size-15 text-color">{{ trans?.amount }}</td>
                    <td class="font-size-15 text-color">{{ trans?.status }}</td>
                    <td class="font-size-15 text-color">
                      {{ trans?.notes.aptid }}
                    </td>
                    <td class="font-size-15 text-color">
                      {{ trans?.apdate | date: dateFormat }}
                    </td>
                    <td class="font-size-15 text-color">{{ trans?.aptime }}</td>
                  </tr>
                  <tbody>
                    <tr></tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row" *ngIf="transactions && transactions?.length > 0">
        <div class="col-md-12 mb-5">
          <button
            type="button"
            class="btn btn-primary btn-rounded text-white pl-4 pr-4 mr-4 mt-md-1 mt-2"
            [disabled]="!selectedTransactions"
            (click)="payout()"
          >
            PAYOUT
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<div
  class="container-fluid"
  *ngIf="transactions?.length === 0 || !transactions"
>
  <div class="row">
    <div class="col-lg-12">
      <div class="card m-b-30">
        <div class="card-body">
          <div class="row">
            <div class="col-lg-12 mt-2 text-center">
              <h5 class="text-danger">NO TRANSACTION FOUND</h5>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
